// Google Maps JS API — loaded via Google's official inline bootstrap instead of
// @googlemaps/js-api-loader so we can pass `loading: "async"`. That package never
// appends it, which makes the Maps CSP probe (maps/api/mapsjs/gen_204?csp_test=true)
// fire at script-eval time and log a CORS error in the console. `loading: "async"`
// defers the probe and also silences the "loaded without loading=async" warning.
// Snippet: https://developers.google.com/maps/documentation/javascript/load-maps-js-api

const langMapping = {
    'nl_NL': 'nl',
    'fr_FR': 'fr',
    'en_US': 'en'
};

const fullLang = document.documentElement.lang || 'nl_NL';
const userLanguage = langMapping[fullLang] || fullLang.substring(0, 2);

((g) => {
    var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
    b = b[c] || (b[c] = {});
    var d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(),
        u = () => h || (h = new Promise(async (f, n) => {
            await (a = m.createElement("script"));
            e.set("libraries", [...r] + "");
            for (k in g) e.set(k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()), g[k]);
            e.set("callback", c + ".maps." + q);
            a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
            d[q] = f;
            a.onerror = () => h = n(Error(p + " could not load."));
            a.nonce = m.querySelector("script[nonce]")?.nonce || "";
            m.head.append(a);
        }));
    d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
})({
    key: variables.google_map_key,
    v: "weekly",
    language: userLanguage,
    loading: "async",
});

// Kept API-compatible with the previous @googlemaps/js-api-loader export:
// `loader.load()` resolves `window.google` once the needed libraries are ready,
// so `_map.js` needs no changes.
const loader = {
    load() {
        return Promise.all([
            google.maps.importLibrary('maps'),
            google.maps.importLibrary('marker'),
            google.maps.importLibrary('places'),
        ]).then(([, marker]) => {
            // the inline bootstrap doesn't mirror `marker` onto google.maps automatically
            if (!google.maps.Marker && marker && marker.Marker) {
                google.maps.Marker = marker.Marker;
            }
            return window.google;
        });
    },
};

export { loader };
